import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box, Typography } from "@mui/material";
import feedback_img1 from "../../../assets/images/feedback_img1.png";
import feedback_img2 from "../../../assets/images/feedback_img2.png";
import feedback_img3 from "../../../assets/images/feedback_img3.png";
import AnimatedTitle from "../../../components/AnimatedTitle/AnimatedTitle";
import useUserStore from "../../../store/useUserStore";

const testimonials = [
  {
    img: feedback_img1,
    name: "Данило Нікульшин",
    role: "CEO, Wenocode OU",
    text:
      "Lawgorithm справді допомогли нашій компанії. Тепер усі продукти мають якісну документацію, клієнти задоволені швидкістю роботи та точністю договорів. Кількість запитів на переробку чи уточнення зменшилась на 40-50%.",
  },
  {
    img: feedback_img3, 
    name: "Юрій Кулаковський",
    role: "Full Stack Dev",
    text:
      "Дякую Кості! Вже вдруге звертаюсь до нього за допомогою. Дуже грамотний юрист, консультує не лише з ІТ, а й з багатьох інших сфер. Рекомендую всім, хто має питання щодо договорів.",
  },
  {
    img: feedback_img2,
    name: "Ярослав Стефанюк",
    role: "Solution Architect",
    text:
      "Мені була потрібна консультація щодо військової служби, адже ще не виповнилось 25 років, але в документах було багато помилок. Lawgorithm усе виправили, впорядкували та надали зрозумілу структуру.",
  },
];

const TestimonialSlide = ({ name, role, text, img }) => (
  <Box
    sx={{
      backgroundColor: "rgba(255,255,255,1)",
      width: "100%",
      padding: "24px",
      borderRadius: "16px",
      color: "rgba(11, 25, 62, 1)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: "1280px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        mb: "16px",
      }}
    >
      <Box
        component="img"
        loading="lazy"
        alt={name}
        src={img}
        sx={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          objectFit: "cover"
        }}
      />
      <Box>
        <Typography sx={{ fontWeight: 600, fontSize: "18px", mb: "4px" }}>
          {name}
        </Typography>
        <Typography sx={{ 
          fontWeight: 400, 
          fontSize: "14px", 
          color: "rgba(11, 25, 62, 0.7)",
          textDecoration: "underline",
          textDecorationColor: "#007bff"
        }}>
          {role}
        </Typography>
      </Box>
    </Box>
    <Typography sx={{ 
      fontSize: "14px", 
      lineHeight: 1.6,
      color: "rgba(11, 25, 62, 0.8)"
    }}>
      {text}
    </Typography>
  </Box>
);

export default function FeedbacksBlock({ scrollToRef }) {
  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);

  return (
    <Box
      ref={scrollToRef}
      sx={{
        width: "100%",
        height: "auto",
        px: windowInnerWidth < 960 ? "20px" : "80px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "rgba(11, 25, 62, 1)",
        mt: "257px",
        "@media (min-width: 640px)": {
          mt: "287px",
        },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "1280px" }}>
        <AnimatedTitle
          text="Відгуки"
          whiteColor={true}
          sx={{ mt: "47px", mb: "58px" }}
        />
        <Box sx={{ 
          position: "relative", 
          mb: "80px",
          "& .swiper-wrapper": { alignItems: "stretch" },
          "& .swiper-slide": { display: "flex", height: "auto" },
        }}>
          <Swiper
            spaceBetween={20}
            slidesPerView={windowInnerWidth < 960 ? 1.1 : 3}
            // centeredSlides={windowInnerWidth < 960 ? false : true}
            initialSlide={1}
            loop={true}
          >
            {testimonials.map((t, index) => (
              <SwiperSlide key={`${t.name}-${index}`}>
                <TestimonialSlide name={t.name} role={t.role} text={t.text} img={t.img} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Box>
    </Box>
  );
}
